import apiUrl from '../../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Information from './../Information';
import BookingService from './../../../services/cargobooking.service';
import ClientService from './../../../../clientmanagement/services/clientmanagement.service';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import {Validator} from 'vee-validate';

export default {
  name: 'FlipkartSoftDataUpload',
  components: {
    VueElementLoading,
    Information,
    Treeselect
  },
  props: [],
  data: function() {
    return {
      isLoading: false,
      client:null,
      clientTypeselection:false,
      Clientlist:[],
      filteredClientList:[],
      SKUData:[],
      SKUlist:[],
      filename:'',
      disableclientselection:false,
      totalRecords:0,
      successRecords:{},
      failedRecords:{},
      showresult:false,
      disabled: false,
      showuploadresult: false,
      uploadResultData:[],
      importResultData:[],
      businessaccountname:'',
      clientbusinessdetailid:'',
      clientbusinessaccountid:'',
      activecontract:"",
      ClientType:1,
      showimportbutton:false,
      showimportresult:false,
      logfileid:null
    }
  },
  computed: {

  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    await this.getClientList();
  },
  methods: {
    selectClient(data){
      if(data){
        this.clientTypeselection = true;
        this.clientid = data.clientid;
        this.client = data.label;
        this.businessaccountname = data.businessaccountname
        this.clientbusinessdetailid = data.clientbusinessdetailid;
        this.clientbusinessaccountid = data.clientbusinessaccountid;
        this.disableclientselection = true;
        this.getSKUList(data.id,data.clientbusinessaccountid);
      }
    },

    async getClientList(){
      try{
        this.isLoading = true;
        let inputPayload={};
        let result = await BookingService.GetFlipkartClientList(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200 ) {
          let clientlist = result.data.data;
          for(var i=0;i<clientlist.length;i++){
            this.Clientlist.push({
              'id':clientlist[i].clientid,
              'label':clientlist[i].clientname,
              'clientfiletype':clientlist[i].clientfiletype,
              'businessaccountname':clientlist[i].accountname,
              'clientbusinessdetailid':clientlist[i].clientbusinessdetailid,
              'clientbusinessaccountid':clientlist[i].clientbusinessaccountid,
            });
          }
          this.clientListFilter();
        }
        else{
          this.$alert(result.data.message, "", "error");
        }
      }
      catch(err){
        this.$alert(err,"","error");
      }
    },
    clientListFilter(){
      this.filteredClientList=[];
      this.Clientlist.forEach(client => {
        if(client.clientfiletype == this.ClientType){
          this.filteredClientList.push(client);
        }
      });
    },
    async getSKUList(clientid, clientbusinessaccountid) {
      try {
        if(clientid){
          this.clientid = clientid;
        }
        let InputPayload = {
          clientid: clientid,
          clientbusinessaccountid: clientbusinessaccountid
        }
        let result = await ClientService.getClientSKUList(InputPayload);
        let skudata = result.data.data;
        this.SKUData = this.groupBy(skudata, "productcategory");
        for (var key in this.SKUData) {
          this.SKUlist.push(this.SKUData[key][0].productcategory);
        }
      } catch(err){
        console.log(err);
      }
    },
    groupBy(array, property) {
      var hash = {};
      for (var i = 0; i < array.length; i++) {
        if (!hash[array[i][property]]) hash[array[i][property]] = [];
        hash[array[i][property]].push(array[i]);
      }
      return hash;
    },
    async uploadBookingData(e){
      this.isLoading = true;
      const files = e.target.files;
      if (!files.length) {
        this.isLoading = false;
        this.$refs.files.value=null;
        return ;
      } else if (!/\.(csv|ms-excel|CSV)$/.test(files[0].name.toLowerCase())) {
        this.isLoading = false;
        this.$refs.files.value=null;
        return this.$alert('The upload format is incorrect. Please upload csv format', "", "error");
      }
      try{
        this.filename = e.target.files[0].name;
        this.file = e.target.files[0];
        const fileReader = new FileReader();
      }
      catch (err) {
        this.$refs.files.value=null;
        this.isLoading = false;
        return this.$alert(err,'', "error");
      }
      this.isLoading = false;
    },
    submitFile(){
      this.$validator.validateAll("uploadform").then((result) => {
        if(result){
          this.disabled=true;
          this.startUpload();
        }
      }).catch(() => {
        console.log('errors exist');
        return false;
      });
    },
    async startUpload(){
      try {
        this.disabled = true;
        this.isLoading = true;
        let formData = new FormData();
        formData.append('clientfiletype', this.ClientType);
        formData.append('clientid', this.client.id);
        formData.append('clientname', this.client.label);
        formData.append('businessaccountname', this.businessaccountname);
        formData.append('clientbusinessdetailid', this.clientbusinessdetailid);
        formData.append('clientbusinessaccountid', this.clientbusinessaccountid);
        formData.append('file', this.file);
        formData.append('lastmodifiedby', this.userName);
        let result = await BookingService.FlipkartUpload(formData);
        this.isLoading = false;
        if (result.data.code == 200) {
          this.$alert(result.data.message, "", "success");
          let uploadata = result.data.data;
          this.logfileid = uploadata[0].logfileid;
          this.totalRecords = uploadata.length;
          let logcount = this.groupBy(uploadata, "isvalid");
          if(logcount[1]){
            this.successRecords = logcount[1];
          }
          if(logcount[0]){
            this.failedRecords = logcount[0];
          }
          this.showresult = true;
        }else{
          this.$alert(result.data.message, "", "error");
        }
      } catch(err){
        this.isLoading = false;
        this.$alert(err, "", "error");
        console.log(err);
      }
    },
    async importValidRecords(){
      try {
        this.isLoading = true;
        let inputPayload = {
          fileid: this.logfileid,
          lastmodifiedby: this.userName,
          skulist:this.SKUlist
        }
        let result = await BookingService.PushFlipkartValidRecords(inputPayload);
        this.isLoading = false;
        this.showuploadresult = false;
        this.showimportresult = true;
        this.totalRecords = 0;
        this.successRecords = {};
        this.failedRecords = {};
        if (result.data.code == 200) {
          this.$alert(result.data.message, "", "success");
          let uploadata = result.data.data;
          this.logfileid = uploadata[0].logfileid;
          this.totalRecords = uploadata.length;
          let logcount = this.groupBy(uploadata, "isvalid");
          let pushlogcount = this.groupBy(uploadata, "pushstatus");
          this.importResultData = pushlogcount[1];
          if(logcount[1]){
            this.successRecords = logcount[1];
          }
          if(logcount[0]){
            this.failedRecords = logcount[0];
          }
          this.showresult = true;
        }else{
          this.$alert(result.data.message, "", "error");
        }
      } catch(err){
        this.isLoading = false;
        console.log(err);
      }
    },
    resetform(){
      this.clientTypeselection=false,
      this.showimportresult=false,
      this.ClientType=1,
      this.SKUData = [];
      this.SKUlist = [];
      this.client = null;
      this.logfileid = null;
      this.activecontract = '';
      this.totalRecords = 0;
      this.successRecords = {};
      this.failedRecords = {};
      this.manifestMethods = [];
      this.importResultData = [];
      this.$refs.files.value=null;
      this.filename = "";
      this.file="";
      this.disabled = false;
      this.showresult = false;
      this.showuploadresult=false;
      this.disableclientselection = false;
      this.filteredClientList=[];
      this.clientListFilter();
    },
    openUploadResultData(type){
      this.showuploadresult = true;
      this.uploadResultData = null;
      this.showimportbutton=false;
      if(type=='valid'){
        this.uploadResultData = this.successRecords;
        this.showimportresult = false;
        if(this.successRecords.length>0 || this.importResultData.length!=this.successRecords.length){
          this.showimportbutton=true;
        }
      }else if(type=='invalid'){
        this.showimportresult = false;
        this.showimportbutton=false;
        this.uploadResultData = this.failedRecords;
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/booking/flipkartSoftDataUpload/flipkartSoftDataUpload.component.js